import { handleApiError } from 'utils/api';
import { env } from '../../constants';
import { ASSIGNMENTS_API_URL } from './constants';
import { AssignmentsResponse } from './types';

export const fetchAssignments = async (
  token: string | undefined
): Promise<AssignmentsResponse | undefined> => {
  if (!token) {
    return undefined;
  }

  const response = await fetch(
    `${env.VITE_API_BASE_URL}/${ASSIGNMENTS_API_URL}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
    }
    await handleApiError(response);
  }

  return response.json() as Promise<AssignmentsResponse>;
};
